import React from 'react';
import { Modal, Backdrop, Fade, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CustomModal = ({ open, handleClose, children }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div
                    style={{
                        backgroundColor: 'white',
                        color: 'black',
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        outline: 'none',
                        width: '80vw',  
                        height: '80vh', 
                        overflowY: 'auto',
                        margin: 'auto',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                >
                    <IconButton
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            color: 'red',
                            zIndex:1301
                        }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                    <div style={{ padding: '20px' }}>{children}</div>
                </div>
            </Fade>
        </Modal>
    );
};

export default CustomModal;

  








/* import React from 'react';
import { Modal, Backdrop, Fade, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CustomModal = ({ open, handleClose, children }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
      <div
          style={{
            backgroundColor: 'white',
            color:'black',
            boxShadow: 24,
            borderRadius: '8px',
            outline: 'none', 
            maxWidth: '70vw',
            maxHeight: '85vh', 
            overflowY: 'auto', 
            margin: 'auto',
            position: 'relative', 
          }}
        >
          <IconButton
            style={{
              position:'absolute',
              top: 0,
              right: 0,
              color:'red'
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <div style={{ padding: '5px' }}>
            {children}
          </div>
        </div>
      </Fade>   
    </Modal>
  );
};

export default CustomModal; */
